var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 130,
    viewBox: "0 0 270.703 245.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -145.071,
    y1: 0.5,
    x2: -144.071,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -149.308,
    y1: 0.5,
    x2: -148.308,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -516.933,
    y1: 0.5,
    x2: -515.933,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -390.57,
    y1: 0.5,
    x2: -389.57,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -265.77,
    y1: 0.5,
    x2: -264.77,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -442.997,
    y1: 0.5,
    x2: -441.997,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1.701,
    y1: -0.123,
    x2: -2.293,
    y2: 2.068,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 3.86,
    y1: -1.146,
    x2: -1.488,
    y2: 1.427,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -29.144,
    y1: 0.5,
    x2: -28.144,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -29.781,
    y1: 0.5,
    x2: -28.781,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -26.764,
    y1: 0.5,
    x2: -25.764,
    y2: 0.5,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2.054,
    y1: -2.516,
    x2: -1.227,
    y2: 3.662,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1.55,
    y1: -12.813,
    x2: -1.732,
    y2: -6.636,
    xlinkHref: "#linear-gradient-12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24348",
    "data-name": "Group 24348",
    transform: "translate(-612.833 -249.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M867.944,596.561c-.2,0-.305,0-.316,0a.38.38,0,0,1,.04-.759c.108.007,10.976.45,22.409-8.949a.38.38,0,0,1,.483.587C879.984,596.129,869.84,596.561,867.944,596.561Z",
    transform: "translate(-254.435 -137.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    "data-name": "Path 3627",
    d: "M959.517,610.328a.38.38,0,0,1-.272-.115c-.248-.256-6.081-6.4-6.432-18.218a.38.38,0,1,1,.759-.023c.343,11.51,6.16,17.652,6.219,17.712a.38.38,0,0,1-.273.644Z",
    transform: "translate(-80.864 -154.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    "data-name": "Path 3635",
    d: "M867.944,596.561c-.2,0-.305,0-.316,0a.38.38,0,0,1,.04-.759c.108.007,10.976.45,22.409-8.949a.38.38,0,0,1,.483.587C879.984,596.129,869.84,596.561,867.944,596.561Z",
    transform: "translate(-27.802 -151.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11879",
    "data-name": "Group 11879",
    transform: "translate(795.43 274.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    "data-name": "Path 3674",
    d: "M976.59,304.147a.457.457,0,0,1-.176-.88c.554-.23,1.111-.476,1.656-.73a.457.457,0,1,1,.387.829c-.556.26-1.126.511-1.692.746A.455.455,0,0,1,976.59,304.147Z",
    transform: "translate(-915.775 -243.783)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    "data-name": "Path 3675",
    d: "M888.2,246.6c-.767,0-1.544-.021-2.308-.06a.458.458,0,0,1-.433-.481.464.464,0,0,1,.481-.433c1.219.064,2.45.076,3.68.037h.015a.457.457,0,0,1,.015.914Q888.918,246.6,888.2,246.6Zm7.446-.632a.457.457,0,0,1-.077-.908c1.209-.207,2.419-.467,3.6-.774a.457.457,0,1,1,.231.885c-1.2.313-2.44.579-3.674.79A.446.446,0,0,1,895.641,245.97Zm-15.724-.161a.435.435,0,0,1-.087-.009c-1.223-.237-2.453-.531-3.655-.873a.458.458,0,0,1,.251-.88c1.177.336,2.381.624,3.578.855a.458.458,0,0,1-.086.907Zm-9.3-2.922a.454.454,0,0,1-.185-.039c-1.142-.506-2.275-1.067-3.369-1.668a.457.457,0,0,1,.441-.8c1.07.588,2.18,1.137,3.3,1.633a.458.458,0,0,1-.186.876Zm-8.415-4.918a.456.456,0,0,1-.273-.091c-1-.746-1.982-1.544-2.915-2.372a.457.457,0,0,1,.607-.684c.914.811,1.875,1.592,2.855,2.322a.457.457,0,0,1-.274.824Zm-7.116-6.656a.456.456,0,0,1-.348-.16c-.812-.95-1.592-1.945-2.319-2.957a.457.457,0,1,1,.743-.533c.711.992,1.475,1.966,2.27,2.9a.457.457,0,0,1-.347.755Zm-5.464-8.064a.457.457,0,0,1-.406-.245c-.579-1.1-1.118-2.248-1.6-3.4a.457.457,0,1,1,.843-.354c.473,1.127,1,2.246,1.568,3.328a.457.457,0,0,1-.4.67Zm-3.528-9.081a.457.457,0,0,1-.442-.341c-.318-1.206-.588-2.441-.8-3.671a.458.458,0,1,1,.9-.157c.209,1.2.474,2.414.785,3.594a.457.457,0,0,1-.326.559A.467.467,0,0,1,846.094,214.167Zm-1.42-9.641a.457.457,0,0,1-.457-.441q-.029-.8-.029-1.587c0-.723.018-1.454.053-2.172a.452.452,0,0,1,.479-.435.457.457,0,0,1,.435.479c-.034.7-.052,1.419-.052,2.127q0,.775.028,1.555a.458.458,0,0,1-.441.473Zm.741-9.72a.452.452,0,0,1-.086-.008.457.457,0,0,1-.364-.535c.234-1.226.524-2.457.862-3.659a.457.457,0,1,1,.881.248c-.331,1.177-.615,2.382-.844,3.582A.458.458,0,0,1,845.415,194.807Z",
    transform: "translate(-844.189 -182.897)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    "data-name": "Path 3676",
    d: "M852.678,176.723a.457.457,0,0,1-.418-.641c.245-.557.507-1.12.78-1.676a.458.458,0,1,1,.821.4c-.267.543-.524,1.1-.763,1.64A.458.458,0,0,1,852.678,176.723Z",
    transform: "translate(-848.547 -174.151)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11880",
    "data-name": "Group 11880",
    transform: "translate(824.002 249.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    "data-name": "Path 3677",
    d: "M907.1,126.827a.457.457,0,0,1-.158-.887c.579-.212,1.168-.414,1.749-.6a.458.458,0,0,1,.278.872c-.568.182-1.144.379-1.712.587A.459.459,0,0,1,907.1,126.827Z",
    transform: "translate(-906.645 -123.294)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3678",
    "data-name": "Path 3678",
    d: "M972.381,179.206a.457.457,0,0,1-.435-.6c.383-1.139.721-2.309,1.006-3.479a.458.458,0,0,1,.889.216c-.292,1.195-.637,2.391-1.027,3.554A.457.457,0,0,1,972.381,179.206Zm2.024-9.375-.047,0a.458.458,0,0,1-.409-.5c.122-1.2.194-2.414.215-3.616a.451.451,0,0,1,.465-.449.458.458,0,0,1,.45.465c-.022,1.228-.1,2.47-.22,3.693A.458.458,0,0,1,974.4,169.832Zm-.081-9.592a.458.458,0,0,1-.454-.4c-.141-1.2-.333-2.4-.572-3.575a.457.457,0,1,1,.9-.182c.244,1.2.441,2.428.584,3.65a.458.458,0,0,1-.4.508Zm-2.156-9.342a.458.458,0,0,1-.432-.306c-.4-1.135-.849-2.266-1.341-3.363a.457.457,0,0,1,.835-.374c.5,1.119.964,2.275,1.371,3.434a.458.458,0,0,1-.281.583A.449.449,0,0,1,972.168,150.9Zm-4.154-8.636a.457.457,0,0,1-.388-.215c-.638-1.019-1.326-2.023-2.047-2.985a.457.457,0,0,1,.732-.549c.736.983,1.44,2.008,2.091,3.048a.457.457,0,0,1-.145.63A.449.449,0,0,1,968.014,142.262Zm-5.948-7.518a.459.459,0,0,1-.325-.136c-.845-.856-1.737-1.687-2.65-2.468a.458.458,0,1,1,.6-.7c.932.8,1.842,1.646,2.705,2.52a.458.458,0,0,1-.325.779Zm-7.444-6.045a.459.459,0,0,1-.247-.073c-1.014-.653-2.064-1.27-3.123-1.833a.457.457,0,0,1,.429-.808c1.082.575,2.155,1.2,3.19,1.871a.458.458,0,0,1-.248.842Zm-8.583-4.279a.453.453,0,0,1-.158-.028c-1.129-.414-2.289-.786-3.45-1.1a.458.458,0,0,1,.242-.883c1.185.325,2.37.7,3.523,1.128a.457.457,0,0,1-.157.887Zm-22.533-2a.458.458,0,0,1-.078-.908c1.206-.21,2.44-.372,3.667-.482a.458.458,0,1,1,.081.912c-1.2.107-2.41.266-3.59.472A.469.469,0,0,1,923.506,122.418Zm13.217-.287a.438.438,0,0,1-.06,0c-1.192-.156-2.406-.262-3.607-.317a.458.458,0,0,1,.042-.914c1.226.057,2.465.166,3.683.324a.458.458,0,0,1-.059.911Z",
    transform: "translate(-915.545 -120.894)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3679",
    "data-name": "Path 3679",
    d: "M1023.5,260.966a.458.458,0,0,1-.4-.678c.292-.53.574-1.07.839-1.6a.457.457,0,0,1,.819.408c-.271.545-.559,1.1-.856,1.637A.457.457,0,0,1,1023.5,260.966Z",
    transform: "translate(-969.797 -195.513)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11881",
    "data-name": "Group 11881",
    transform: "translate(805.45 260.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    "data-name": "Path 3680",
    d: "M927.222,196.864a.525.525,0,0,0,.07-.6l-3.072-5.578a27.738,27.738,0,0,0,3.022-8.464l5.905-2.373a.523.523,0,0,0,.328-.512l-.382-7.629a.524.524,0,0,0-.377-.476l-6.113-1.771a27.745,27.745,0,0,0-3.854-8.12l2.5-5.858a.523.523,0,0,0-.13-.593l-5.665-5.124a.524.524,0,0,0-.6-.07l-5.578,3.072a27.742,27.742,0,0,0-8.464-3.022l-2.373-5.905a.523.523,0,0,0-.512-.328l-7.63.382a.523.523,0,0,0-.477.377l-1.771,6.113a27.737,27.737,0,0,0-8.12,3.853l-5.858-2.5a.523.523,0,0,0-.593.13l-5.125,5.665a.524.524,0,0,0-.07.6l3.073,5.578a27.727,27.727,0,0,0-3.023,8.465l-5.905,2.373a.524.524,0,0,0-.328.512l.382,7.629a.523.523,0,0,0,.377.476l6.114,1.771a27.716,27.716,0,0,0,3.854,8.12l-2.5,5.858a.523.523,0,0,0,.13.593l5.665,5.124a.523.523,0,0,0,.6.07l5.579-3.072a27.735,27.735,0,0,0,8.465,3.022l2.373,5.906a.522.522,0,0,0,.511.327l7.629-.382a.524.524,0,0,0,.477-.377l1.771-6.113a27.744,27.744,0,0,0,8.12-3.854l5.858,2.5a.523.523,0,0,0,.593-.13Z",
    transform: "translate(-866.096 -143.506)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    "data-name": "Path 3681",
    d: "M930.884,215.759a7.47,7.47,0,1,1,2.184-.328A7.482,7.482,0,0,1,930.884,215.759Zm0-13.57a6.13,6.13,0,0,0-1.794.271,6.1,6.1,0,1,0,7.616,4.043h0a6.107,6.107,0,0,0-5.821-4.313Z",
    transform: "translate(-897.191 -174.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    d: "M916.774,213.381a19.142,19.142,0,0,1-19.084-18.162q-.024-.486-.025-.967a19.119,19.119,0,0,1,38.214-.947q.024.483.024.966a19.222,19.222,0,0,1-.25,3.1l-1.354-.222a17.84,17.84,0,0,0,.233-2.876q0-.449-.022-.9h0a17.746,17.746,0,0,0-35.471.871q0,.452.023.906a17.75,17.75,0,0,0,27.587,13.868l.764,1.14a19.091,19.091,0,0,1-9.67,3.2C917.418,213.373,917.095,213.381,916.774,213.381Z",
    transform: "translate(-883.225 -160.67)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    d: "M390,144.5H528.693a14.369,14.369,0,0,1,14.35,13.638l10.238,201.082a10.6,10.6,0,0,1-10.39,11.133L383.93,373.24a10.057,10.057,0,0,1-10.241-10.056V160.807A16.309,16.309,0,0,1,390,144.5Z",
    transform: "translate(278.348 122.624)",
    fill: "#0c1b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M415.158,675.164h0l-17.787-.23a10.97,10.97,0,0,1-10.786-10.927V637.153a.38.38,0,1,1,.759,0v26.855a10.208,10.208,0,0,0,10.037,10.167l17.787.23a.38.38,0,0,1,0,.759Z",
    transform: "translate(270.352 -182.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M386.96,608.523a.38.38,0,0,1-.38-.38v-4.349a.38.38,0,0,1,.759,0v4.349A.38.38,0,0,1,386.96,608.523Z",
    transform: "translate(270.352 -162.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    d: "M420.623,166.531c18.227,2.472,76.9,5.345,128.723,1.367a4.216,4.216,0,0,1,4.54,3.976l10.33,194.373a4.851,4.851,0,0,1-4.557,5.1c-21.8,1.289-111.553,6.276-143.569,2.922a3.844,3.844,0,0,1-3.439-3.8l.211-197.317C412.845,170.376,417.874,166.158,420.623,166.531Z",
    transform: "translate(254.183 107.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23641",
    "data-name": "Group 23641",
    transform: "translate(709.941 338.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23634",
    "data-name": "Group 23634",
    transform: "translate(113.537 143.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    d: "M3336.463,1537.828c2.774.24,7.588.629,11.383.8a10.951,10.951,0,0,0,4.351-.426c0,.085,0,.166-.007.241a.785.785,0,0,1-.746.741,133.336,133.336,0,0,1-14.9.015.559.559,0,0,1-.456-.84A4.517,4.517,0,0,1,3336.463,1537.828Z",
    transform: "translate(-3336.005 -1528.235)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    "data-name": "Path 3940",
    d: "M3348.982,1524.709c-3.795-.167-8.61-.557-11.383-.8,2.727-3.346,11.383-5.6,11.383-5.6h2.445a10.25,10.25,0,0,1,1.906,5.972A10.957,10.957,0,0,1,3348.982,1524.709Z",
    transform: "translate(-3337.142 -1514.32)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M3375.883,1504.4l-.229,4.528a1.033,1.033,0,0,1-.883.972,4.027,4.027,0,0,1-1.836-.152,1.224,1.224,0,0,1-.822-.94l-.79-4.407Z",
    transform: "translate(-3361.186 -1504.405)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23636",
    "data-name": "Group 23636",
    transform: "translate(151.778 139.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23635",
    "data-name": "Group 23635",
    transform: "translate(1.077 4.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    d: "M3487.459,1536.855a2.195,2.195,0,0,0,1.976-1.461l0,.018a1.563,1.563,0,0,1-1.054,1.782,6.874,6.874,0,0,1-2.917.457,2.9,2.9,0,0,1-2.187-1.008l-.007-.009C3484.181,1537.082,3485.453,1537.135,3487.459,1536.855Z",
    transform: "translate(-3480.327 -1526.47)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    d: "M3474.464,1504.3h2.017c3.071-.063,5,6.415,5.631,8.923a2.2,2.2,0,0,1-1.976,1.461c-2.006.28-3.278.227-4.185-.221a19.266,19.266,0,0,1-2.876-7.247A2.543,2.543,0,0,1,3474.464,1504.3Z",
    transform: "translate(-3473.005 -1504.302)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    "data-name": "Path 3944",
    d: "M3473.546,1489.663l1.12,4.453a1.209,1.209,0,0,1-.628,1.37,4.293,4.293,0,0,1-2.318.562,1.012,1.012,0,0,1-.825-.674l-1.644-4.685Z",
    transform: "translate(-3469.251 -1489.663)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3945",
    "data-name": "Path 3945",
    d: "M3381.951,1336.867c-1.393,1.235-5.924,1.4-5.924,1.4-16.32-39.17-23-44.734-23-44.734,2.355,14.784.379,47.515.379,47.515-2.693,1.188-6.166,0-6.166,0a252.26,252.26,0,0,0-8.333-61.953c11.031-.248,16.9-4.023,18.812-5.537C3366.917,1288.379,3381.951,1336.867,3381.951,1336.867Z",
    transform: "translate(-3224.541 -1196.535)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3946",
    "data-name": "Path 3946",
    d: "M3318.154,1115.941c2.088,10.414,1.339,29.053.848,37.554-.139,2.389,1.53,5.7,2.878,7.962a.709.709,0,0,1-.286,1,49.165,49.165,0,0,1-18.768,5.2,1.264,1.264,0,0,1-1.272-.944c-6.574-24.549-14.21-40.235-14.21-40.235C3295.774,1113.016,3318.154,1115.941,3318.154,1115.941Z",
    transform: "translate(-3187.774 -1083.965)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3947",
    "data-name": "Path 3947",
    d: "M3367.4,1323.868a.523.523,0,0,0,.447-.794,16.4,16.4,0,0,0-6.471-5.618.523.523,0,0,0-.455.941,15.626,15.626,0,0,1,6.032,5.22A.524.524,0,0,0,3367.4,1323.868Z",
    transform: "translate(-3240.021 -1227.799)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23637",
    "data-name": "Group 23637",
    transform: "translate(128.048 31.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3948",
    "data-name": "Path 3948",
    d: "M3420.145,1218.946a35.816,35.816,0,0,1-6.615,15.764l-1.507-1.228a46.531,46.531,0,0,0,.75-15.066A18.033,18.033,0,0,1,3420.145,1218.946Z",
    transform: "translate(-3404.718 -1189.059)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3949",
    "data-name": "Path 3949",
    d: "M3386.57,1129.458l2.333-12.85s15.581,11.91,13.1,29.888a18.037,18.037,0,0,0-7.372-.53C3393.913,1140.2,3391.785,1133.933,3386.57,1129.458Z",
    transform: "translate(-3386.57 -1116.608)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23638",
    "data-name": "Group 23638",
    transform: "translate(80.6 42.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3950",
    "data-name": "Path 3950",
    d: "M3273.163,1153.325l6.015,12.952c-.973,7.819-5.173,11.2-9.7,12.5a27.5,27.5,0,0,0-2.02-8.435C3273.242,1164.365,3273.163,1153.325,3273.163,1153.325Z",
    transform: "translate(-3254.193 -1153.325)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    "data-name": "Path 3951",
    d: "M3234.51,1212.61a27.488,27.488,0,0,1,2.02,8.435c-12.084,4.688-15.282-4.4-15.282-4.4l2.234-.394C3228.524,1216.778,3232.048,1215.152,3234.51,1212.61Z",
    transform: "translate(-3221.248 -1195.595)",
    fill: "#f8ac72"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    "data-name": "Path 3952",
    d: "M3306.65,1090.459l2.9,10.673a2.076,2.076,0,0,0,2.777,1.382,42.156,42.156,0,0,0,4.185-1.911,2.8,2.8,0,0,0,.986-4.021l-6.036-9Z",
    transform: "translate(-3201.538 -1063.936)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    "data-name": "Path 3953",
    d: "M3197.3,1201.767l74.4,27.078a5.7,5.7,0,0,1,3.237,7.711l-.226.5a5.3,5.3,0,0,1-7.043,2.614l-72.24-33.418Z",
    transform: "translate(-3122.233 -1145.35)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1525",
    "data-name": "Ellipse 1525",
    cx: 36.726,
    cy: 36.064,
    rx: 36.726,
    ry: 36.064,
    transform: "translate(4.141 4.065)",
    opacity: 0.21,
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    "data-name": "Path 3954",
    d: "M2940.412,1045.323c0,22.163,18.3,40.129,40.866,40.129s40.866-17.966,40.866-40.129-18.3-40.129-40.866-40.129S2940.412,1023.16,2940.412,1045.323Zm6,0c0-18.907,15.609-34.234,34.864-34.234s34.864,15.327,34.864,34.234-15.61,34.234-34.864,34.234S2946.415,1064.23,2946.415,1045.323Z",
    transform: "translate(-2940.412 -1005.194)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    "data-name": "Path 3955",
    d: "M3069.059,1056.456a.28.28,0,0,1-.242-.313c.12-.935.2-1.889.25-2.835a.267.267,0,0,1,.293-.266.28.28,0,0,1,.266.293c-.048.961-.134,1.929-.255,2.878a.279.279,0,0,1-.277.244Zm-.52-11.45a36.372,36.372,0,0,0-2.172-7.432v0a37.642,37.642,0,0,0-35.032-23.181,38.165,38.165,0,0,0-20.288,5.8.28.28,0,1,1-.3-.474,38.728,38.728,0,0,1,20.585-5.883,38.2,38.2,0,0,1,35.55,23.529,37,37,0,0,1,2.206,7.547.281.281,0,0,1-.227.325.381.381,0,0,1-.05,0A.28.28,0,0,1,3068.539,1045.006Z",
    transform: "translate(-2990.469 -1011.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23640",
    "data-name": "Group 23640",
    transform: "translate(95.744 12.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    "data-name": "Path 3956",
    d: "M3284.517,1065.1c-.026.183,2.421,12.18,2.421,12.18l6.82-1.544-.631-11.715S3284.96,1062.03,3284.517,1065.1Z",
    transform: "translate(-3281.5 -1059.366)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    d: "M3284.1,1056.644l.815,6.141a.825.825,0,0,1,0,.235c-.068.481-.427,2.12-2.081,1.651-1.5-.425-2.877-.791-3.828-.5a.863.863,0,0,0-.595,1,37.42,37.42,0,0,0,1.569,5.59.863.863,0,0,0,1.048.51,27.844,27.844,0,0,0,6.012-2.46.864.864,0,0,0,.421-.779c-.065-1.55-.247-6.262-.094-7.584.143-1.24,1.665-1.983,2.326-2.249a.849.849,0,0,0,.474-.475,2.243,2.243,0,0,0-1.509-3.27.867.867,0,0,1-.549-1.121,2.247,2.247,0,0,0-1.26-3.106,3.169,3.169,0,0,0-3.782.911.867.867,0,0,1-1.1.131.684.684,0,0,0-.779.026.853.853,0,0,1-1.208-.366,2.583,2.583,0,0,0-3-1.5c-3.056.523-3.4,3.91-2.6,5.895s4.088,1.229,5.734.228c1.252-.761,2.875.036,3.581.462A.858.858,0,0,1,3284.1,1056.644Z",
    transform: "translate(-3274.007 -1049.379)",
    fill: "#b79f2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    "data-name": "Path 3958",
    d: "M3320.154,1083.876s-1.256-3.518.035-4.38,3.2-.415,2.781,2.134C3322.447,1084.8,3320.154,1083.876,3320.154,1083.876Z",
    transform: "translate(-3306.518 -1070.567)",
    fill: "#f8ac72"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3959",
    "data-name": "Path 3959",
    d: "M3389.149,1269.221l-7.032-.573-3.047,2.808s.721,1,2.974.424a32.226,32.226,0,0,1,5.338-.713s3.111,1.4,3.148-1.221Z",
    transform: "translate(-3253.173 -1193.036)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3960",
    "data-name": "Path 3960",
    d: "M3212.582,1219.223c-.608.475-2.692-.517-3.967-1.2a1.469,1.469,0,0,1-.709-1.733c.307-.968.819-2.217,1.448-2.375C3210.4,1213.651,3215.089,1217.264,3212.582,1219.223Z",
    transform: "translate(-3131.084 -1153.999)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    "data-name": "Path 3961",
    d: "M3435.013,1300.951a.292.292,0,0,0,.092-.015c2.908-1.006,3.585-2.725,3.64-3.99a4.431,4.431,0,0,0-2.889-4.27l-8.933-3.483a.28.28,0,1,0-.2.521l8.932,3.483a3.872,3.872,0,0,1,2.534,3.725c-.068,1.587-1.167,2.76-3.264,3.485a.28.28,0,0,0,.091.544Z",
    transform: "translate(-3287.019 -1207.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3962",
    "data-name": "Path 3962",
    d: "M3414.353,1284.871a.28.28,0,0,0,.1-.54l-1.158-.452a.28.28,0,0,0-.2.521l1.157.451A.276.276,0,0,0,3414.353,1284.871Z",
    transform: "translate(-3277.304 -1203.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3963",
    "data-name": "Path 3963",
    d: "M3026.99,1061.916h0c2.118-.849,4.843-.342,6.04,1.123l5.626,6.89a1.753,1.753,0,0,0,2.51-.074l13.955-21.224c.7-1.059,3-.7,2.979.459-.143,6.492-2.664,18.833-17.849,29.162,0,0-8.368-2.222-15.107-12.331C3024.171,1064.461,3024.964,1062.728,3026.99,1061.916Z",
    transform: "translate(-3000.532 -1035.715)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3964",
    "data-name": "Path 3964",
    d: "M3048.455,1143.931h0c-2.118.849-4.844.343-6.039-1.122l-5.626-6.89a1.755,1.755,0,0,0-2.511.075l-13.955,21.224c-.7,1.059-3,.7-2.979-.459.143-6.492,2.664-18.833,17.849-29.162,0,0,8.368,2.222,15.107,12.331C3051.274,1141.387,3050.481,1143.119,3048.455,1143.931Z",
    transform: "translate(-2995.265 -1092.466)",
    fill: "url(#linear-gradient-13)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.6e25d18c89f09d8a1cd426a40980feee.svg";
export { ForwardRef as ReactComponent };